import { Box, Button, ListItem, ListItemProps } from '@mui/material'
import NextLink from 'next/link'
import { useRouter } from 'next/router'

interface NavItemProps extends ListItemProps {
    href: string
    icon: JSX.Element
    title: string
}

export const NavItem = (props: NavItemProps) => {
    const { href, icon, title, ...others } = props
    const router = useRouter()
    // Active controls highlighting of navItem
    // Highlighted if user on matching page
    let active = href ? router.pathname.startsWith(href) : false

    // Specific condition for the root ("/") route
    if (href === '/' && router.pathname !== '/') {
        active = false
    }

    return (
        <ListItem
            disableGutters
            sx={{
                display: 'flex',
                width: '258px',
                py: 0,
            }}
            {...others}
        >
            <NextLink href={href} passHref>
                <Button
                    data-test="nav-item"
                    startIcon={icon}
                    disableRipple
                    sx={{
                        backgroundColor: active ? 'rgba(42, 45, 51, 1)' : undefined,
                        borderRadius: 0,
                        color: active ? 'rgba(186, 226, 251, 1)' : 'rgba(255, 255, 255, 1)',
                        fontWeight: 700,
                        justifyContent: 'flex-start',
                        textAlign: 'left',
                        textTransform: 'none',
                        minWidth: '258px',
                        height: '68px',
                        width: '100%',
                        padding: '0px ',
                        margin: '0px',
                        paddingLeft: '30px',
                        borderTop: '1px solid  rgba(42, 45, 51, 1)',
                        borderLeft: active ? '4px solid rgba(21, 110, 188, 1)' : '4px solid rgba(255,255,255, 0)',
                        borderBottom: '1px solid rgba(255, 255, 255, 0.15)',
                        '& .MuiButton-startIcon': {
                            color: active ? 'rgba(186, 226, 251, 1)' : 'rgba(255, 255, 255, 1)',
                        },
                        '&:hover': {
                            backgroundColor: 'rgba(42, 45, 51, 1)',
                            borderLeft: '4px solid rgba(255,255,255, 0)',
                            outline: 'none',
                            textDecoration: 'none',
                        },
                        '&:focus': {
                            backgroundColor: 'rgba(255,255,255, 0.08)',
                            outline: 'none',
                            color: 'rgba(255, 255, 255, 1)',
                            textDecoration: 'none',
                            borderColor: 'rgba(42, 45, 51, 1)',
                            borderLeft: '4px solid rgba(21, 110, 188, 1)',
                        },
                        '&:active': {
                            backgroundColor: 'rgba(255,255,255, 0.08)',
                            border: 'none',
                            outline: 'none',
                            color: 'rgba(255, 255, 255, 1)',
                            textDecoration: 'none',
                            borderColor: 'rgba(42, 45, 51, 1)',
                            borderLeft: '4px solid rgba(21, 110, 188, 1)',
                        },
                    }}
                >
                    <Box sx={{ flexGrow: 1 }}>{title}</Box>
                </Button>
            </NextLink>
        </ListItem>
    )
}
